import {Layers3} from "lucide-react";
import {Select, SelectContent, SelectItem, SelectTrigger, SelectValue} from "@/components/ui/select.tsx";
import {useDungeonEditorSession} from "./DungeonEditorSession.tsx";

export default function DungeonEditorLevelSelect() {
    const {levels, activeLevel, selectLevel} = useDungeonEditorSession();

    return <Select value={activeLevel?.id} onValueChange={selectLevel}>
        <SelectTrigger size="sm" aria-label="Level auswählen" className="w-36 sm:w-44">
            <Layers3/>
            <SelectValue placeholder="Level wählen"/>
        </SelectTrigger>
        <SelectContent>
            {levels.map((level, index) => <SelectItem key={level.id} value={level.id}>
                {level.name || `Level ${index + 1}`}
            </SelectItem>)}
        </SelectContent>
    </Select>;
}
